import React, { useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';

// === COMPONENTS ===
import { useTaskComplete } from 'components/useTaskComplete';

// === API ===
import { on, removeListener, submitTask } from 'api/prokey/prokey.websocket';

//-----------------------------------------------------------------
function TaskCompleteModal() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const completion_status = useTaskComplete();

  const [          mode, setMode          ] = useState('');
  const [     showModal, setShowModal     ] = useState(false);
  const [hasClosedModal, setHasClosedModal] = useState(false);
  
  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if (!completion_status.is_complete) {
      setHasClosedModal(false);
    }
    setTimeout(() => setShowModal(!hasClosedModal && completion_status.is_complete), 100);

    const is_auto_mode = localStorage.getItem('auto-mode') === 'true';
    if (is_auto_mode && completion_status.is_complete) {
      submitTask();
      return;
    }

    const is_batch_auto_submit = localStorage.getItem('setting-task-submit') === '1';
    const is_correct_all = mode === 'CORRECT-ALL';
    if (is_batch_auto_submit && completion_status.is_complete && !is_correct_all) {
      submitTask();
      return;
    }

    if (completion_status.is_complete) {
      document.addEventListener('keydown', onKeyDown);
    } else document.removeEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [completion_status, mode]);

  useEffect( () => {

    function _handleCorrectionMode(data) {
      setMode(data)
    }

    on( 'CORRECTION-MODE', _handleCorrectionMode );

    return () => {
      removeListener( 'CORRECTION-MODE', _handleCorrectionMode );
    }
  }, [])

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if (event.key === 'Enter' && event.altKey) {
      submitTask();
    }
  }

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    setHasClosedModal(true);
    setShowModal(false);
  }

  //-----------------------------------------------------------------
  function handleSubmit() {
    //-----------------------------------------------------------------
    submitTask();
    setShowModal(false);
  }
  
  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return showModal ? (
      <Dialog open={showModal} onClose={handleClose}>
        <DialogTitle>Finished Processing Task</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            If you'd like to complete this task click 'Submit', otherwise click 'Close' to go back and review the task.
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            If you don't see any fields you may need to set the correction mode to 'Show All Fields'.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button name='back_to_task_btn' onClick={handleClose} color='primary'>
            Close
          </Button>
          <Button name='submit_task_btn' onClick={handleSubmit} color='primary'>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    ) : null;
  }

  //#endregion

  return display();
}

export { TaskCompleteModal };
